/**
 * Notifications API service — in-app bildirim kutusu (N2)
 *
 * N1 backend'i (PROD'da ✅) tüketir. Token/Authorization ELLE yönetilmez —
 * apiFetch getAccessToken ile otomatik Bearer ekler, 401-refresh ve superseded
 * akışını da o katman sağlar (D-04, T-N2-01). Bu servis hiç token'a dokunmaz.
 */
import { apiFetch } from '@/lib/api-client'

const NOTIFICATIONS_BASE = '/notifications'

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type NotificationTargetType = 'broadcast' | 'plan' | 'user' | 'group'

/**
 * N1 `notification_models.py` `to_dict()` + service `is_read` alanlarını birebir
 * yansıtır. is_read backend'de g.current_user['id'] bazında hesaplanır (N1).
 */
export interface NotificationItem {
  id: string
  title: string
  body: string
  target_type: NotificationTargetType
  target_value: string | null
  created_by: string | null
  created_at: string
  expires_at: string | null
  is_active: boolean
  is_read: boolean
}

// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------

/** GET /notifications → success zarfının `data` dizisi (NotificationItem[]). */
export async function getNotifications(): Promise<NotificationItem[]> {
  const res = await apiFetch<{ success: boolean; data: NotificationItem[] }>(
    NOTIFICATIONS_BASE
  )
  return res.data
}

/** GET /notifications/unread-count → `data.unread_count` (number). */
export async function getUnreadCount(): Promise<number> {
  const res = await apiFetch<{ success: boolean; data: { unread_count: number } }>(
    `${NOTIFICATIONS_BASE}/unread-count`
  )
  return res.data.unread_count
}

/** POST /notifications/:id/read → okundu işaretle (dönüş kullanılmaz). */
export async function markNotificationRead(notificationId: string): Promise<void> {
  await apiFetch(`${NOTIFICATIONS_BASE}/${notificationId}/read`, { method: 'POST' })
}
